import type { CollegeConference, CollegeTeam } from "./types.ts";

export const COLLEGE_CONFERENCES: CollegeConference[] = [
	{ cid: 0, name: "America East", abbrev: "AE" },
	{ cid: 1, name: "American Athletic", abbrev: "AAC" },
	{ cid: 2, name: "Atlantic 10", abbrev: "A10" },
	{ cid: 3, name: "ACC", abbrev: "ACC" },
	{ cid: 4, name: "ASUN", abbrev: "ASUN" },
	{ cid: 5, name: "Big 12", abbrev: "B12" },
	{ cid: 6, name: "Big East", abbrev: "BE" },
	{ cid: 7, name: "Big Sky", abbrev: "BSKY" },
	{ cid: 8, name: "Big South", abbrev: "BSO" },
	{ cid: 9, name: "Big Ten", abbrev: "B1G" },
	{ cid: 10, name: "Big West", abbrev: "BW" },
	{ cid: 11, name: "CAA", abbrev: "CAA" },
	{ cid: 12, name: "Conference USA", abbrev: "CUSA" },
	{ cid: 13, name: "Horizon League", abbrev: "HOR" },
	{ cid: 14, name: "Ivy League", abbrev: "IVY" },
	{ cid: 15, name: "MAAC", abbrev: "MAAC" },
	{ cid: 16, name: "MAC", abbrev: "MAC" },
	{ cid: 17, name: "MEAC", abbrev: "MEAC" },
	{ cid: 18, name: "Missouri Valley", abbrev: "MVC" },
	{ cid: 19, name: "Mountain West", abbrev: "MWC" },
	{ cid: 20, name: "Northeast", abbrev: "NEC" },
	{ cid: 21, name: "Ohio Valley", abbrev: "OVC" },
	{ cid: 22, name: "Pac-12", abbrev: "P12" },
	{ cid: 23, name: "Patriot League", abbrev: "PAT" },
	{ cid: 24, name: "SEC", abbrev: "SEC" },
	{ cid: 25, name: "Southern", abbrev: "SOCON" },
	{ cid: 26, name: "Southland", abbrev: "SLC" },
	{ cid: 27, name: "SWAC", abbrev: "SWAC" },
	{ cid: 28, name: "Summit League", abbrev: "SUM" },
	{ cid: 29, name: "Sun Belt", abbrev: "SBC" },
	{ cid: 30, name: "WAC", abbrev: "WAC" },
	{ cid: 31, name: "West Coast", abbrev: "WCC" },
];

export const COLLEGE_TEAMS: CollegeTeam[] = [
	{ tid: 0, cid: 0, region: "Albany", name: "Great Danes", abbrev: "ALB" },
	{ tid: 1, cid: 0, region: "Binghamton", name: "Bearcats", abbrev: "BING" },
	{ tid: 2, cid: 0, region: "Bryant", name: "Bulldogs", abbrev: "BRY" },
	{ tid: 3, cid: 0, region: "Maine", name: "Black Bears", abbrev: "ME" },
	{ tid: 4, cid: 0, region: "NJIT", name: "Highlanders", abbrev: "NJIT" },
	{ tid: 5, cid: 0, region: "New Hampshire", name: "Wildcats", abbrev: "UNH" },
	{ tid: 6, cid: 0, region: "UMBC", name: "Retrievers", abbrev: "UMBC" },
	{ tid: 7, cid: 0, region: "UMass Lowell", name: "River Hawks", abbrev: "UML" },
	{ tid: 8, cid: 0, region: "Vermont", name: "Catamounts", abbrev: "UVM" },
	{ tid: 9, cid: 1, region: "Charlotte", name: "49ers", abbrev: "CHAR" },
	{ tid: 10, cid: 1, region: "East Carolina", name: "Pirates", abbrev: "ECU" },
	{ tid: 11, cid: 1, region: "Florida Atlantic", name: "Owls", abbrev: "FAU" },
	{ tid: 12, cid: 1, region: "Memphis", name: "Tigers", abbrev: "MEM" },
	{ tid: 13, cid: 1, region: "North Texas", name: "Mean Green", abbrev: "UNT" },
	{ tid: 14, cid: 1, region: "Rice", name: "Owls", abbrev: "RICE" },
	{ tid: 15, cid: 1, region: "South Florida", name: "Bulls", abbrev: "USF" },
	{ tid: 16, cid: 1, region: "Temple", name: "Owls", abbrev: "TEM" },
	{ tid: 17, cid: 1, region: "Tulane", name: "Green Wave", abbrev: "TULN" },
	{ tid: 18, cid: 1, region: "Tulsa", name: "Golden Hurricane", abbrev: "TLSA" },
	{ tid: 19, cid: 1, region: "UAB", name: "Blazers", abbrev: "UAB" },
	{ tid: 20, cid: 1, region: "UTSA", name: "Roadrunners", abbrev: "UTSA" },
	{ tid: 21, cid: 1, region: "Wichita State", name: "Shockers", abbrev: "WICH" },
	{ tid: 22, cid: 2, region: "Davidson", name: "Wildcats", abbrev: "DAV" },
	{ tid: 23, cid: 2, region: "Dayton", name: "Flyers", abbrev: "DAY" },
	{ tid: 24, cid: 2, region: "Duquesne", name: "Dukes", abbrev: "DUQ" },
	{ tid: 25, cid: 2, region: "Fordham", name: "Rams", abbrev: "FOR" },
	{ tid: 26, cid: 2, region: "George Mason", name: "Patriots", abbrev: "GMU" },
	{ tid: 27, cid: 2, region: "George Washington", name: "Revolutionaries", abbrev: "GW" },
	{ tid: 28, cid: 2, region: "La Salle", name: "Explorers", abbrev: "LAS" },
	{ tid: 29, cid: 2, region: "Loyola Chicago", name: "Ramblers", abbrev: "LUC" },
	{ tid: 30, cid: 2, region: "Rhode Island", name: "Rams", abbrev: "URI" },
	{ tid: 31, cid: 2, region: "Richmond", name: "Spiders", abbrev: "RICH" },
	{ tid: 32, cid: 2, region: "Saint Joseph's", name: "Hawks", abbrev: "JOES" },
	{ tid: 33, cid: 2, region: "Saint Louis", name: "Billikens", abbrev: "SLU" },
	{ tid: 34, cid: 2, region: "St. Bonaventure", name: "Bonnies", abbrev: "SBON" },
	{ tid: 35, cid: 2, region: "UMass", name: "Minutemen", abbrev: "MASS" },
	{ tid: 36, cid: 2, region: "VCU", name: "Rams", abbrev: "VCU" },
	{ tid: 37, cid: 3, region: "Boston College", name: "Eagles", abbrev: "BC" },
	{ tid: 38, cid: 3, region: "California", name: "Golden Bears", abbrev: "CAL" },
	{ tid: 39, cid: 3, region: "Clemson", name: "Tigers", abbrev: "CLEM" },
	{ tid: 40, cid: 3, region: "Duke", name: "Blue Devils", abbrev: "DUKE" },
	{ tid: 41, cid: 3, region: "Florida State", name: "Seminoles", abbrev: "FSU" },
	{ tid: 42, cid: 3, region: "Georgia Tech", name: "Yellow Jackets", abbrev: "GT" },
	{ tid: 43, cid: 3, region: "Louisville", name: "Cardinals", abbrev: "LOU" },
	{ tid: 44, cid: 3, region: "Miami", name: "Hurricanes", abbrev: "MIA" },
	{ tid: 45, cid: 3, region: "NC State", name: "Wolfpack", abbrev: "NCST" },
	{ tid: 46, cid: 3, region: "North Carolina", name: "Tar Heels", abbrev: "UNC" },
	{ tid: 47, cid: 3, region: "Notre Dame", name: "Fighting Irish", abbrev: "ND" },
	{ tid: 48, cid: 3, region: "Pittsburgh", name: "Panthers", abbrev: "PITT" },
	{ tid: 49, cid: 3, region: "SMU", name: "Mustangs", abbrev: "SMU" },
	{ tid: 50, cid: 3, region: "Stanford", name: "Cardinal", abbrev: "STAN" },
	{ tid: 51, cid: 3, region: "Syracuse", name: "Orange", abbrev: "SYR" },
	{ tid: 52, cid: 3, region: "Virginia", name: "Cavaliers", abbrev: "UVA" },
	{ tid: 53, cid: 3, region: "Virginia Tech", name: "Hokies", abbrev: "VT" },
	{ tid: 54, cid: 3, region: "Wake Forest", name: "Demon Deacons", abbrev: "WAKE" },
	{ tid: 55, cid: 4, region: "Austin Peay", name: "Governors", abbrev: "APSU" },
	{ tid: 56, cid: 4, region: "Bellarmine", name: "Knights", abbrev: "BELL" },
	{ tid: 57, cid: 4, region: "Central Arkansas", name: "Bears", abbrev: "UCA" },
	{ tid: 58, cid: 4, region: "Eastern Kentucky", name: "Colonels", abbrev: "EKU" },
	{ tid: 59, cid: 4, region: "Florida Gulf Coast", name: "Eagles", abbrev: "FGCU" },
	{ tid: 60, cid: 4, region: "Jacksonville", name: "Dolphins", abbrev: "JAC" },
	{ tid: 61, cid: 4, region: "Lipscomb", name: "Bisons", abbrev: "LIP" },
	{ tid: 62, cid: 4, region: "North Alabama", name: "Lions", abbrev: "UNA" },
	{ tid: 63, cid: 4, region: "North Florida", name: "Ospreys", abbrev: "UNF" },
	{ tid: 64, cid: 4, region: "Queens", name: "Royals", abbrev: "QUC" },
	{ tid: 65, cid: 4, region: "Stetson", name: "Hatters", abbrev: "STET" },
	{ tid: 66, cid: 4, region: "West Georgia", name: "Wolves", abbrev: "UWG" },
	{ tid: 67, cid: 5, region: "Arizona", name: "Wildcats", abbrev: "ARIZ" },
	{ tid: 68, cid: 5, region: "Arizona State", name: "Sun Devils", abbrev: "ASU" },
	{ tid: 69, cid: 5, region: "Baylor", name: "Bears", abbrev: "BAY" },
	{ tid: 70, cid: 5, region: "BYU", name: "Cougars", abbrev: "BYU" },
	{ tid: 71, cid: 5, region: "Cincinnati", name: "Bearcats", abbrev: "CIN" },
	{ tid: 72, cid: 5, region: "Colorado", name: "Buffaloes", abbrev: "COLO" },
	{ tid: 73, cid: 5, region: "Houston", name: "Cougars", abbrev: "HOU" },
	{ tid: 74, cid: 5, region: "Iowa State", name: "Cyclones", abbrev: "ISU" },
	{ tid: 75, cid: 5, region: "Kansas", name: "Jayhawks", abbrev: "KU" },
	{ tid: 76, cid: 5, region: "Kansas State", name: "Wildcats", abbrev: "KSU" },
	{ tid: 77, cid: 5, region: "Oklahoma State", name: "Cowboys", abbrev: "OKST" },
	{ tid: 78, cid: 5, region: "TCU", name: "Horned Frogs", abbrev: "TCU" },
	{ tid: 79, cid: 5, region: "Texas Tech", name: "Red Raiders", abbrev: "TTU" },
	{ tid: 80, cid: 5, region: "UCF", name: "Knights", abbrev: "UCF" },
	{ tid: 81, cid: 5, region: "Utah", name: "Utes", abbrev: "UTAH" },
	{ tid: 82, cid: 5, region: "West Virginia", name: "Mountaineers", abbrev: "WVU" },
	{ tid: 83, cid: 6, region: "Butler", name: "Bulldogs", abbrev: "BUT" },
	{ tid: 84, cid: 6, region: "Creighton", name: "Bluejays", abbrev: "CREI" },
	{ tid: 85, cid: 6, region: "DePaul", name: "Blue Demons", abbrev: "DEP" },
	{ tid: 86, cid: 6, region: "Georgetown", name: "Hoyas", abbrev: "GTWN" },
	{ tid: 87, cid: 6, region: "Marquette", name: "Golden Eagles", abbrev: "MARQ" },
	{ tid: 88, cid: 6, region: "Providence", name: "Friars", abbrev: "PROV" },
	{ tid: 89, cid: 6, region: "Seton Hall", name: "Pirates", abbrev: "HALL" },
	{ tid: 90, cid: 6, region: "St. John's", name: "Red Storm", abbrev: "SJN" },
	{ tid: 91, cid: 6, region: "UConn", name: "Huskies", abbrev: "CONN" },
	{ tid: 92, cid: 6, region: "Villanova", name: "Wildcats", abbrev: "NOVA" },
	{ tid: 93, cid: 6, region: "Xavier", name: "Musketeers", abbrev: "XAV" },
	{ tid: 94, cid: 7, region: "Eastern Washington", name: "Eagles", abbrev: "EWU" },
	{ tid: 95, cid: 7, region: "Idaho", name: "Vandals", abbrev: "IDHO" },
	{ tid: 96, cid: 7, region: "Idaho State", name: "Bengals", abbrev: "IDST" },
	{ tid: 97, cid: 7, region: "Montana", name: "Grizzlies", abbrev: "MONT" },
	{ tid: 98, cid: 7, region: "Montana State", name: "Bobcats", abbrev: "MTST" },
	{ tid: 99, cid: 7, region: "Northern Arizona", name: "Lumberjacks", abbrev: "NAU" },
	{ tid: 100, cid: 7, region: "Northern Colorado", name: "Bears", abbrev: "UNCO" },
	{ tid: 101, cid: 7, region: "Portland State", name: "Vikings", abbrev: "PRST" },
	{ tid: 102, cid: 7, region: "Sacramento State", name: "Hornets", abbrev: "SAC" },
	{ tid: 103, cid: 7, region: "Weber State", name: "Wildcats", abbrev: "WEB" },
	{ tid: 104, cid: 8, region: "Charleston Southern", name: "Buccaneers", abbrev: "CHSO" },
	{ tid: 105, cid: 8, region: "Gardner-Webb", name: "Runnin' Bulldogs", abbrev: "GWEB" },
	{ tid: 106, cid: 8, region: "High Point", name: "Panthers", abbrev: "HPU" },
	{ tid: 107, cid: 8, region: "Longwood", name: "Lancers", abbrev: "LONG" },
	{ tid: 108, cid: 8, region: "Presbyterian", name: "Blue Hose", abbrev: "PRE" },
	{ tid: 109, cid: 8, region: "Radford", name: "Highlanders", abbrev: "RAD" },
	{ tid: 110, cid: 8, region: "UNC Asheville", name: "Bulldogs", abbrev: "UNCA" },
	{ tid: 111, cid: 8, region: "USC Upstate", name: "Spartans", abbrev: "UPST" },
	{ tid: 112, cid: 8, region: "Winthrop", name: "Eagles", abbrev: "WIN" },
	{ tid: 113, cid: 9, region: "Illinois", name: "Fighting Illini", abbrev: "ILL" },
	{ tid: 114, cid: 9, region: "Indiana", name: "Hoosiers", abbrev: "IND" },
	{ tid: 115, cid: 9, region: "Iowa", name: "Hawkeyes", abbrev: "IOWA" },
	{ tid: 116, cid: 9, region: "Maryland", name: "Terrapins", abbrev: "MD" },
	{ tid: 117, cid: 9, region: "Michigan", name: "Wolverines", abbrev: "MICH" },
	{ tid: 118, cid: 9, region: "Michigan State", name: "Spartans", abbrev: "MSU" },
	{ tid: 119, cid: 9, region: "Minnesota", name: "Golden Gophers", abbrev: "MINN" },
	{ tid: 120, cid: 9, region: "Nebraska", name: "Cornhuskers", abbrev: "NEB" },
	{ tid: 121, cid: 9, region: "Northwestern", name: "Wildcats", abbrev: "NW" },
	{ tid: 122, cid: 9, region: "Ohio State", name: "Buckeyes", abbrev: "OSU" },
	{ tid: 123, cid: 9, region: "Oregon", name: "Ducks", abbrev: "ORE" },
	{ tid: 124, cid: 9, region: "Penn State", name: "Nittany Lions", abbrev: "PSU" },
	{ tid: 125, cid: 9, region: "Purdue", name: "Boilermakers", abbrev: "PUR" },
	{ tid: 126, cid: 9, region: "Rutgers", name: "Scarlet Knights", abbrev: "RUT" },
	{ tid: 127, cid: 9, region: "UCLA", name: "Bruins", abbrev: "UCLA" },
	{ tid: 128, cid: 9, region: "USC", name: "Trojans", abbrev: "USC" },
	{ tid: 129, cid: 9, region: "Washington", name: "Huskies", abbrev: "WASH" },
	{ tid: 130, cid: 9, region: "Wisconsin", name: "Badgers", abbrev: "WISC" },
	{ tid: 131, cid: 10, region: "Cal Poly", name: "Mustangs", abbrev: "CP" },
	{ tid: 132, cid: 10, region: "Cal State Bakersfield", name: "Roadrunners", abbrev: "CSUB" },
	{ tid: 133, cid: 10, region: "Cal State Fullerton", name: "Titans", abbrev: "CSUF" },
	{ tid: 134, cid: 10, region: "Cal State Northridge", name: "Matadors", abbrev: "CSUN" },
	{ tid: 135, cid: 10, region: "Hawaii", name: "Rainbow Warriors", abbrev: "HAW" },
	{ tid: 136, cid: 10, region: "Long Beach State", name: "Beach", abbrev: "LBSU" },
	{ tid: 137, cid: 10, region: "UC Davis", name: "Aggies", abbrev: "UCD" },
	{ tid: 138, cid: 10, region: "UC Irvine", name: "Anteaters", abbrev: "UCI" },
	{ tid: 139, cid: 10, region: "UC Riverside", name: "Highlanders", abbrev: "UCR" },
	{ tid: 140, cid: 10, region: "UC San Diego", name: "Tritons", abbrev: "UCSD" },
	{ tid: 141, cid: 10, region: "UC Santa Barbara", name: "Gauchos", abbrev: "UCSB" },
	{ tid: 142, cid: 11, region: "Campbell", name: "Fighting Camels", abbrev: "CAM" },
	{ tid: 143, cid: 11, region: "Charleston", name: "Cougars", abbrev: "COFC" },
	{ tid: 144, cid: 11, region: "Delaware", name: "Blue Hens", abbrev: "DEL" },
	{ tid: 145, cid: 11, region: "Drexel", name: "Dragons", abbrev: "DREX" },
	{ tid: 146, cid: 11, region: "Elon", name: "Phoenix", abbrev: "ELON" },
	{ tid: 147, cid: 11, region: "Hampton", name: "Pirates", abbrev: "HAMP" },
	{ tid: 148, cid: 11, region: "Hofstra", name: "Pride", abbrev: "HOF" },
	{ tid: 149, cid: 11, region: "Monmouth", name: "Hawks", abbrev: "MONM" },
	{ tid: 150, cid: 11, region: "North Carolina A&T", name: "Aggies", abbrev: "NCAT" },
	{ tid: 151, cid: 11, region: "Northeastern", name: "Huskies", abbrev: "NEU" },
	{ tid: 152, cid: 11, region: "Stony Brook", name: "Seawolves", abbrev: "STBK" },
	{ tid: 153, cid: 11, region: "Towson", name: "Tigers", abbrev: "TOW" },
	{ tid: 154, cid: 11, region: "UNC Wilmington", name: "Seahawks", abbrev: "UNCW" },
	{ tid: 155, cid: 11, region: "William & Mary", name: "Tribe", abbrev: "W&M" },
	{ tid: 156, cid: 12, region: "Florida International", name: "Panthers", abbrev: "FIU" },
	{ tid: 157, cid: 12, region: "Jacksonville State", name: "Gamecocks", abbrev: "JVST" },
	{ tid: 158, cid: 12, region: "Kennesaw State", name: "Owls", abbrev: "KENN" },
	{ tid: 159, cid: 12, region: "Liberty", name: "Flames", abbrev: "LIB" },
	{ tid: 160, cid: 12, region: "Louisiana Tech", name: "Bulldogs", abbrev: "LT" },
	{ tid: 161, cid: 12, region: "Middle Tennessee", name: "Blue Raiders", abbrev: "MTSU" },
	{ tid: 162, cid: 12, region: "New Mexico State", name: "Aggies", abbrev: "NMSU" },
	{ tid: 163, cid: 12, region: "Sam Houston", name: "Bearkats", abbrev: "SHSU" },
	{ tid: 164, cid: 12, region: "UTEP", name: "Miners", abbrev: "UTEP" },
	{ tid: 165, cid: 12, region: "Western Kentucky", name: "Hilltoppers", abbrev: "WKU" },
	{ tid: 166, cid: 13, region: "Cleveland State", name: "Vikings", abbrev: "CLEV" },
	{ tid: 167, cid: 13, region: "Detroit Mercy", name: "Titans", abbrev: "DETM" },
	{ tid: 168, cid: 13, region: "Green Bay", name: "Phoenix", abbrev: "GB" },
	{ tid: 169, cid: 13, region: "IU Indianapolis", name: "Jaguars", abbrev: "IUIN" },
	{ tid: 170, cid: 13, region: "Milwaukee", name: "Panthers", abbrev: "MILW" },
	{ tid: 171, cid: 13, region: "Northern Kentucky", name: "Norse", abbrev: "NKU" },
	{ tid: 172, cid: 13, region: "Oakland", name: "Golden Grizzlies", abbrev: "OAK" },
	{ tid: 173, cid: 13, region: "Purdue Fort Wayne", name: "Mastodons", abbrev: "PFW" },
	{ tid: 174, cid: 13, region: "Robert Morris", name: "Colonials", abbrev: "RMU" },
	{ tid: 175, cid: 13, region: "Wright State", name: "Raiders", abbrev: "WRST" },
	{ tid: 176, cid: 13, region: "Youngstown State", name: "Penguins", abbrev: "YSU" },
	{ tid: 177, cid: 14, region: "Brown", name: "Bears", abbrev: "BRWN" },
	{ tid: 178, cid: 14, region: "Columbia", name: "Lions", abbrev: "COLU" },
	{ tid: 179, cid: 14, region: "Cornell", name: "Big Red", abbrev: "COR" },
	{ tid: 180, cid: 14, region: "Dartmouth", name: "Big Green", abbrev: "DART" },
	{ tid: 181, cid: 14, region: "Harvard", name: "Crimson", abbrev: "HARV" },
	{ tid: 182, cid: 14, region: "Penn", name: "Quakers", abbrev: "PENN" },
	{ tid: 183, cid: 14, region: "Princeton", name: "Tigers", abbrev: "PRIN" },
	{ tid: 184, cid: 14, region: "Yale", name: "Bulldogs", abbrev: "YALE" },
	{ tid: 185, cid: 15, region: "Canisius", name: "Golden Griffins", abbrev: "CAN" },
	{ tid: 186, cid: 15, region: "Fairfield", name: "Stags", abbrev: "FAIR" },
	{ tid: 187, cid: 15, region: "Iona", name: "Gaels", abbrev: "IONA" },
	{ tid: 188, cid: 15, region: "Manhattan", name: "Jaspers", abbrev: "MAN" },
	{ tid: 189, cid: 15, region: "Marist", name: "Red Foxes", abbrev: "MRST" },
	{ tid: 190, cid: 15, region: "Mount St. Mary's", name: "Mountaineers", abbrev: "MSM" },
	{ tid: 191, cid: 15, region: "Niagara", name: "Purple Eagles", abbrev: "NIA" },
	{ tid: 192, cid: 15, region: "Quinnipiac", name: "Bobcats", abbrev: "QUIN" },
	{ tid: 193, cid: 15, region: "Rider", name: "Broncs", abbrev: "RID" },
	{ tid: 194, cid: 15, region: "Sacred Heart", name: "Pioneers", abbrev: "SHU" },
	{ tid: 195, cid: 15, region: "Saint Peter's", name: "Peacocks", abbrev: "SPU" },
	{ tid: 196, cid: 15, region: "Siena", name: "Saints", abbrev: "SIE" },
	{ tid: 197, cid: 16, region: "Akron", name: "Zips", abbrev: "AKR" },
	{ tid: 198, cid: 16, region: "Ball State", name: "Cardinals", abbrev: "BALL" },
	{ tid: 199, cid: 16, region: "Bowling Green", name: "Falcons", abbrev: "BGSU" },
	{ tid: 200, cid: 16, region: "Buffalo", name: "Bulls", abbrev: "BUFF" },
	{ tid: 201, cid: 16, region: "Central Michigan", name: "Chippewas", abbrev: "CMU" },
	{ tid: 202, cid: 16, region: "Eastern Michigan", name: "Eagles", abbrev: "EMU" },
	{ tid: 203, cid: 16, region: "Kent State", name: "Golden Flashes", abbrev: "KENT" },
	{ tid: 204, cid: 16, region: "Miami (OH)", name: "RedHawks", abbrev: "M-OH" },
	{ tid: 205, cid: 16, region: "Northern Illinois", name: "Huskies", abbrev: "NIU" },
	{ tid: 206, cid: 16, region: "Ohio", name: "Bobcats", abbrev: "OHIO" },
	{ tid: 207, cid: 16, region: "Toledo", name: "Rockets", abbrev: "TOL" },
	{ tid: 208, cid: 16, region: "Western Michigan", name: "Broncos", abbrev: "WMU" },
	{ tid: 209, cid: 17, region: "Coppin State", name: "Eagles", abbrev: "COPP" },
	{ tid: 210, cid: 17, region: "Delaware State", name: "Hornets", abbrev: "DSU" },
	{ tid: 211, cid: 17, region: "Howard", name: "Bison", abbrev: "HOW" },
	{ tid: 212, cid: 17, region: "Maryland Eastern Shore", name: "Hawks", abbrev: "UMES" },
	{ tid: 213, cid: 17, region: "Morgan State", name: "Bears", abbrev: "MORG" },
	{ tid: 214, cid: 17, region: "Norfolk State", name: "Spartans", abbrev: "NORF" },
	{ tid: 215, cid: 17, region: "North Carolina Central", name: "Eagles", abbrev: "NCCU" },
	{ tid: 216, cid: 17, region: "South Carolina State", name: "Bulldogs", abbrev: "SCST" },
	{ tid: 217, cid: 18, region: "Belmont", name: "Bruins", abbrev: "BEL" },
	{ tid: 218, cid: 18, region: "Bradley", name: "Braves", abbrev: "BRAD" },
	{ tid: 219, cid: 18, region: "Drake", name: "Bulldogs", abbrev: "DRKE" },
	{ tid: 220, cid: 18, region: "Evansville", name: "Purple Aces", abbrev: "EVAN" },
	{ tid: 221, cid: 18, region: "Illinois State", name: "Redbirds", abbrev: "ILST" },
	{ tid: 222, cid: 18, region: "Indiana State", name: "Sycamores", abbrev: "INST" },
	{ tid: 223, cid: 18, region: "Missouri State", name: "Bears", abbrev: "MOST" },
	{ tid: 224, cid: 18, region: "Murray State", name: "Racers", abbrev: "MUR" },
	{ tid: 225, cid: 18, region: "Northern Iowa", name: "Panthers", abbrev: "UNI" },
	{ tid: 226, cid: 18, region: "Southern Illinois", name: "Salukis", abbrev: "SIU" },
	{ tid: 227, cid: 18, region: "UIC", name: "Flames", abbrev: "UIC" },
	{ tid: 228, cid: 18, region: "Valparaiso", name: "Beacons", abbrev: "VAL" },
	{ tid: 229, cid: 19, region: "Air Force", name: "Falcons", abbrev: "AFA" },
	{ tid: 230, cid: 19, region: "Boise State", name: "Broncos", abbrev: "BSU" },
	{ tid: 231, cid: 19, region: "Colorado State", name: "Rams", abbrev: "CSU" },
	{ tid: 232, cid: 19, region: "Fresno State", name: "Bulldogs", abbrev: "FRES" },
	{ tid: 233, cid: 19, region: "Nevada", name: "Wolf Pack", abbrev: "NEV" },
	{ tid: 234, cid: 19, region: "New Mexico", name: "Lobos", abbrev: "UNM" },
	{ tid: 235, cid: 19, region: "San Diego State", name: "Aztecs", abbrev: "SDSU" },
	{ tid: 236, cid: 19, region: "San Jose State", name: "Spartans", abbrev: "SJSU" },
	{ tid: 237, cid: 19, region: "UNLV", name: "Rebels", abbrev: "UNLV" },
	{ tid: 238, cid: 19, region: "Utah State", name: "Aggies", abbrev: "USU" },
	{ tid: 239, cid: 19, region: "Wyoming", name: "Cowboys", abbrev: "WYO" },
	{ tid: 240, cid: 20, region: "Central Connecticut", name: "Blue Devils", abbrev: "CCSU" },
	{ tid: 241, cid: 20, region: "Chicago State", name: "Cougars", abbrev: "CHST" },
	{ tid: 242, cid: 20, region: "Fairleigh Dickinson", name: "Knights", abbrev: "FDU" },
	{ tid: 243, cid: 20, region: "Le Moyne", name: "Dolphins", abbrev: "LEM" },
	{ tid: 244, cid: 20, region: "LIU", name: "Sharks", abbrev: "LIU" },
	{ tid: 245, cid: 20, region: "Mercyhurst", name: "Lakers", abbrev: "MERC" },
	{ tid: 246, cid: 20, region: "Merrimack", name: "Warriors", abbrev: "MRMK" },
	{ tid: 247, cid: 20, region: "Saint Francis (PA)", name: "Red Flash", abbrev: "SFPA" },
	{ tid: 248, cid: 20, region: "Stonehill", name: "Skyhawks", abbrev: "STO" },
	{ tid: 249, cid: 20, region: "Wagner", name: "Seahawks", abbrev: "WAG" },
	{ tid: 250, cid: 21, region: "Eastern Illinois", name: "Panthers", abbrev: "EIU" },
	{ tid: 251, cid: 21, region: "Little Rock", name: "Trojans", abbrev: "UALR" },
	{ tid: 252, cid: 21, region: "Lindenwood", name: "Lions", abbrev: "LIN" },
	{ tid: 253, cid: 21, region: "Morehead State", name: "Eagles", abbrev: "MORE" },
	{ tid: 254, cid: 21, region: "Southeast Missouri", name: "Redhawks", abbrev: "SEMO" },
	{ tid: 255, cid: 21, region: "Southern Indiana", name: "Screaming Eagles", abbrev: "USI" },
	{ tid: 256, cid: 21, region: "SIU Edwardsville", name: "Cougars", abbrev: "SIUE" },
	{ tid: 257, cid: 21, region: "Tennessee State", name: "Tigers", abbrev: "TNST" },
	{ tid: 258, cid: 21, region: "Tennessee Tech", name: "Golden Eagles", abbrev: "TNTC" },
	{ tid: 259, cid: 21, region: "UT Martin", name: "Skyhawks", abbrev: "UTM" },
	{ tid: 260, cid: 21, region: "Western Illinois", name: "Leathernecks", abbrev: "WIU" },
	{ tid: 261, cid: 22, region: "Oregon State", name: "Beavers", abbrev: "ORST" },
	{ tid: 262, cid: 22, region: "Washington State", name: "Cougars", abbrev: "WSU" },
	{ tid: 263, cid: 23, region: "American", name: "Eagles", abbrev: "AMER" },
	{ tid: 264, cid: 23, region: "Army", name: "Black Knights", abbrev: "ARMY" },
	{ tid: 265, cid: 23, region: "Boston University", name: "Terriers", abbrev: "BU" },
	{ tid: 266, cid: 23, region: "Bucknell", name: "Bison", abbrev: "BUCK" },
	{ tid: 267, cid: 23, region: "Colgate", name: "Raiders", abbrev: "COLG" },
	{ tid: 268, cid: 23, region: "Holy Cross", name: "Crusaders", abbrev: "HC" },
	{ tid: 269, cid: 23, region: "Lafayette", name: "Leopards", abbrev: "LAF" },
	{ tid: 270, cid: 23, region: "Lehigh", name: "Mountain Hawks", abbrev: "LEH" },
	{ tid: 271, cid: 23, region: "Loyola Maryland", name: "Greyhounds", abbrev: "L-MD" },
	{ tid: 272, cid: 23, region: "Navy", name: "Midshipmen", abbrev: "NAVY" },
	{ tid: 273, cid: 24, region: "Alabama", name: "Crimson Tide", abbrev: "ALA" },
	{ tid: 274, cid: 24, region: "Arkansas", name: "Razorbacks", abbrev: "ARK" },
	{ tid: 275, cid: 24, region: "Auburn", name: "Tigers", abbrev: "AUB" },
	{ tid: 276, cid: 24, region: "Florida", name: "Gators", abbrev: "FLA" },
	{ tid: 277, cid: 24, region: "Georgia", name: "Bulldogs", abbrev: "UGA" },
	{ tid: 278, cid: 24, region: "Kentucky", name: "Wildcats", abbrev: "UK" },
	{ tid: 279, cid: 24, region: "LSU", name: "Tigers", abbrev: "LSU" },
	{ tid: 280, cid: 24, region: "Mississippi State", name: "Bulldogs", abbrev: "MSST" },
	{ tid: 281, cid: 24, region: "Missouri", name: "Tigers", abbrev: "MIZ" },
	{ tid: 282, cid: 24, region: "Oklahoma", name: "Sooners", abbrev: "OU" },
	{ tid: 283, cid: 24, region: "Ole Miss", name: "Rebels", abbrev: "MISS" },
	{ tid: 284, cid: 24, region: "South Carolina", name: "Gamecocks", abbrev: "SCAR" },
	{ tid: 285, cid: 24, region: "Tennessee", name: "Volunteers", abbrev: "TENN" },
	{ tid: 286, cid: 24, region: "Texas", name: "Longhorns", abbrev: "TEX" },
	{ tid: 287, cid: 24, region: "Texas A&M", name: "Aggies", abbrev: "TAMU" },
	{ tid: 288, cid: 24, region: "Vanderbilt", name: "Commodores", abbrev: "VAN" },
	{ tid: 289, cid: 25, region: "Chattanooga", name: "Mocs", abbrev: "CHAT" },
	{ tid: 290, cid: 25, region: "The Citadel", name: "Bulldogs", abbrev: "CIT" },
	{ tid: 291, cid: 25, region: "East Tennessee State", name: "Buccaneers", abbrev: "ETSU" },
	{ tid: 292, cid: 25, region: "Furman", name: "Paladins", abbrev: "FUR" },
	{ tid: 293, cid: 25, region: "Mercer", name: "Bears", abbrev: "MER" },
	{ tid: 294, cid: 25, region: "Samford", name: "Bulldogs", abbrev: "SAM" },
	{ tid: 295, cid: 25, region: "UNC Greensboro", name: "Spartans", abbrev: "UNCG" },
	{ tid: 296, cid: 25, region: "VMI", name: "Keydets", abbrev: "VMI" },
	{ tid: 297, cid: 25, region: "Western Carolina", name: "Catamounts", abbrev: "WCU" },
	{ tid: 298, cid: 25, region: "Wofford", name: "Terriers", abbrev: "WOF" },
	{ tid: 299, cid: 26, region: "Houston Christian", name: "Huskies", abbrev: "HCU" },
	{ tid: 300, cid: 26, region: "Incarnate Word", name: "Cardinals", abbrev: "UIW" },
	{ tid: 301, cid: 26, region: "Lamar", name: "Cardinals", abbrev: "LAM" },
	{ tid: 302, cid: 26, region: "McNeese", name: "Cowboys", abbrev: "MCN" },
	{ tid: 303, cid: 26, region: "New Orleans", name: "Privateers", abbrev: "UNO" },
	{ tid: 304, cid: 26, region: "Nicholls", name: "Colonels", abbrev: "NICH" },
	{ tid: 305, cid: 26, region: "Northwestern State", name: "Demons", abbrev: "NWST" },
	{ tid: 306, cid: 26, region: "Southeastern Louisiana", name: "Lions", abbrev: "SELA" },
	{ tid: 307, cid: 26, region: "Texas A&M-Corpus Christi", name: "Islanders", abbrev: "AMCC" },
	{ tid: 308, cid: 26, region: "UT Rio Grande Valley", name: "Vaqueros", abbrev: "UTRGV" },
	{ tid: 309, cid: 27, region: "Alabama A&M", name: "Bulldogs", abbrev: "AAMU" },
	{ tid: 310, cid: 27, region: "Alabama State", name: "Hornets", abbrev: "ALST" },
	{ tid: 311, cid: 27, region: "Alcorn State", name: "Braves", abbrev: "ALCN" },
	{ tid: 312, cid: 27, region: "Arkansas-Pine Bluff", name: "Golden Lions", abbrev: "UAPB" },
	{ tid: 313, cid: 27, region: "Bethune-Cookman", name: "Wildcats", abbrev: "BCU" },
	{ tid: 314, cid: 27, region: "Florida A&M", name: "Rattlers", abbrev: "FAMU" },
	{ tid: 315, cid: 27, region: "Grambling", name: "Tigers", abbrev: "GRAM" },
	{ tid: 316, cid: 27, region: "Jackson State", name: "Tigers", abbrev: "JKST" },
	{ tid: 317, cid: 27, region: "Mississippi Valley State", name: "Delta Devils", abbrev: "MVSU" },
	{ tid: 318, cid: 27, region: "Prairie View A&M", name: "Panthers", abbrev: "PV" },
	{ tid: 319, cid: 27, region: "Southern", name: "Jaguars", abbrev: "SOU" },
	{ tid: 320, cid: 27, region: "Texas Southern", name: "Tigers", abbrev: "TXSO" },
	{ tid: 321, cid: 28, region: "Denver", name: "Pioneers", abbrev: "DEN" },
	{ tid: 322, cid: 28, region: "Kansas City", name: "Roos", abbrev: "KC" },
	{ tid: 323, cid: 28, region: "North Dakota", name: "Fighting Hawks", abbrev: "UND" },
	{ tid: 324, cid: 28, region: "North Dakota State", name: "Bison", abbrev: "NDSU" },
	{ tid: 325, cid: 28, region: "Omaha", name: "Mavericks", abbrev: "OMA" },
	{ tid: 326, cid: 28, region: "Oral Roberts", name: "Golden Eagles", abbrev: "ORU" },
	{ tid: 327, cid: 28, region: "South Dakota", name: "Coyotes", abbrev: "SDAK" },
	{ tid: 328, cid: 28, region: "South Dakota State", name: "Jackrabbits", abbrev: "SDST" },
	{ tid: 329, cid: 28, region: "St. Thomas", name: "Tommies", abbrev: "UST" },
	{ tid: 330, cid: 29, region: "Appalachian State", name: "Mountaineers", abbrev: "APP" },
	{ tid: 331, cid: 29, region: "Arkansas State", name: "Red Wolves", abbrev: "ARST" },
	{ tid: 332, cid: 29, region: "Coastal Carolina", name: "Chanticleers", abbrev: "CCU" },
	{ tid: 333, cid: 29, region: "Georgia Southern", name: "Eagles", abbrev: "GASO" },
	{ tid: 334, cid: 29, region: "Georgia State", name: "Panthers", abbrev: "GAST" },
	{ tid: 335, cid: 29, region: "James Madison", name: "Dukes", abbrev: "JMU" },
	{ tid: 336, cid: 29, region: "Louisiana", name: "Ragin' Cajuns", abbrev: "UL" },
	{ tid: 337, cid: 29, region: "Louisiana-Monroe", name: "Warhawks", abbrev: "ULM" },
	{ tid: 338, cid: 29, region: "Marshall", name: "Thundering Herd", abbrev: "MRSH" },
	{ tid: 339, cid: 29, region: "Old Dominion", name: "Monarchs", abbrev: "ODU" },
	{ tid: 340, cid: 29, region: "South Alabama", name: "Jaguars", abbrev: "USA" },
	{ tid: 341, cid: 29, region: "Southern Miss", name: "Golden Eagles", abbrev: "USM" },
	{ tid: 342, cid: 29, region: "Texas State", name: "Bobcats", abbrev: "TXST" },
	{ tid: 343, cid: 29, region: "Troy", name: "Trojans", abbrev: "TROY" },
	{ tid: 344, cid: 30, region: "Abilene Christian", name: "Wildcats", abbrev: "ACU" },
	{ tid: 345, cid: 30, region: "California Baptist", name: "Lancers", abbrev: "CBU" },
	{ tid: 346, cid: 30, region: "Grand Canyon", name: "Lopes", abbrev: "GCU" },
	{ tid: 347, cid: 30, region: "Seattle U", name: "Redhawks", abbrev: "SEA" },
	{ tid: 348, cid: 30, region: "Southern Utah", name: "Thunderbirds", abbrev: "SUU" },
	{ tid: 349, cid: 30, region: "Tarleton State", name: "Texans", abbrev: "TAR" },
	{ tid: 350, cid: 30, region: "Utah Tech", name: "Trailblazers", abbrev: "UTU" },
	{ tid: 351, cid: 30, region: "Utah Valley", name: "Wolverines", abbrev: "UVU" },
	{ tid: 352, cid: 30, region: "UT Arlington", name: "Mavericks", abbrev: "UTA" },
	{ tid: 353, cid: 31, region: "Gonzaga", name: "Bulldogs", abbrev: "GONZ" },
	{ tid: 354, cid: 31, region: "Loyola Marymount", name: "Lions", abbrev: "LMU" },
	{ tid: 355, cid: 31, region: "Pacific", name: "Tigers", abbrev: "PAC" },
	{ tid: 356, cid: 31, region: "Pepperdine", name: "Waves", abbrev: "PEPP" },
	{ tid: 357, cid: 31, region: "Portland", name: "Pilots", abbrev: "PORT" },
	{ tid: 358, cid: 31, region: "Saint Mary's", name: "Gaels", abbrev: "SMC" },
	{ tid: 359, cid: 31, region: "San Diego", name: "Toreros", abbrev: "USD" },
	{ tid: 360, cid: 31, region: "San Francisco", name: "Dons", abbrev: "SF" },
	{ tid: 361, cid: 31, region: "Santa Clara", name: "Broncos", abbrev: "SCU" },
	{ tid: 362, cid: 20, region: "New Haven", name: "Chargers", abbrev: "NHV" },
	{ tid: 363, cid: 26, region: "Stephen F. Austin", name: "Lumberjacks", abbrev: "SFA" },
	{ tid: 364, cid: 12, region: "Missouri State CUSA move placeholder", name: "Bears", abbrev: "MOSTC" },
	{ tid: 365, cid: 30, region: "UTRGV WAC move", name: "Vaqueros", abbrev: "UTRGVW" },
	{ tid: 366, cid: 12, region: "Delaware Blue Hens CUSA", name: "Blue Hens", abbrev: "DELC" },
	{ tid: 367, cid: 21, region: "Murray State OVC historic", name: "Racers", abbrev: "MURO" },
	{ tid: 368, cid: 26, region: "UTRGV", name: "Vaqueros", abbrev: "RGV" },
];

export const collegeTeamCount = COLLEGE_TEAMS.length;
